
import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Dropdown, Form, Table, Button } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';

const StaffPrices = () => {
    const [staffPrices, setStaffPrices] = useState([]);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
    const [years, setYears] = useState([]);
    const [editedPrices, setEditedPrices] = useState({});
    const [newYear, setNewYear] = useState('');
    const [snPrice, setSnPrice] = useState('');
    const [enaPrice, setEnaPrice] = useState('');
    const [cwPrice, setCwPrice] = useState('');

    useEffect(() => {
        const fetchStaffPrices = async () => {
            try {
                const response = await fetch('https://api.cpq.yourcrm.co.za/api/staff/prices');
                if (response.ok) {
                    const data = await response.json();
                    setStaffPrices(data);
                    const uniqueYears = Array.from(new Set(data.map(item => item.Year)));
                    setYears(uniqueYears);
                } else {
                    console.error('Failed to fetch staff prices');
                }
            } catch (error) {
                console.error('An error occurred while fetching staff prices:', error);
            }
        };

        fetchStaffPrices();
    }, []);

    const handlePriceChange = async (id, newPrice) => {
        try {
            const response = await fetch(`https://api.cpq.yourcrm.co.za/api/staff/prices/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ StandardHourlyPrice: parseFloat(newPrice) })
            });

            if (response.ok) {
                const updatedPrice = await response.json();
                setStaffPrices(staffPrices.map(price =>
                    price.StaffID === id ? { ...price, StandardHourlyPrice: updatedPrice.StandardHourlyPrice } : price
                ));
                setEditedPrices(prev => ({ ...prev, [id]: newPrice }));
            } else {
                console.error('Failed to update staff price');
            }
        } catch (error) {
            console.error('An error occurred while updating staff price:', error);
        }
    };

    const handleInputChange = (id, value) => {
        setEditedPrices(prev => ({ ...prev, [id]: value }));
    };

    const handleSavePrice = (id) => {
        const newPrice = editedPrices[id];
        if (newPrice) {
            handlePriceChange(id, newPrice);
        }
    };

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    const handleAddNewYear = async () => {
        try {
            const response = await fetch('https://api.cpq.yourcrm.co.za/api/staff/prices', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Year: newYear,
                    SN: parseFloat(snPrice) || 0,
                    ENA: parseFloat(enaPrice) || 0,
                    CW: parseFloat(cwPrice) || 0
                })
            });
            if (response.ok) {
                const newPrices = await response.json();
                setStaffPrices([...staffPrices, ...newPrices]);
                setYears(prevYears => Array.from(new Set([...prevYears, newYear])));
                setNewYear('');
                setSnPrice('');
                setEnaPrice('');
                setCwPrice('');
            } else {
                console.error('Failed to add new year');
            }
        } catch (error) {
            console.error('An error occurred while adding a new year:', error);
        }
    };

    const filteredStaffPrices = staffPrices.filter(staff => staff.Year === selectedYear);

    return (
        <div>
            <div className="container mt-4">
                <h1>Staff Prices</h1>
                <Form.Group controlId="yearSelect">
                    <Form.Label>Select Financial Year</Form.Label>
                    <Form.Control
                        as="select"
                        value={selectedYear}
                        onChange={handleYearChange}
                    >
                        {years.map(year => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Staff Type</th>
                            <th>Standard Hourly Price</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredStaffPrices.map(staff => (
                            <tr key={staff.StaffID}>
                                <td>{staff.StaffID}</td>
                                <td>
                                    {staff.StaffType === 'SN' && 'Senior Nurse'}
                                    {staff.StaffType === 'ENA' && 'Enrolled Nursing Assistant'}
                                    {staff.StaffType === 'CW' && 'Care Worker'}
                                </td>
                                <td>
                                    <Form.Control
                                        type="number"
                                        value={editedPrices[staff.StaffID] !== undefined ? editedPrices[staff.StaffID] : staff.StandardHourlyPrice}
                                        onChange={(e) => {
                                            const newValue = e.target.value; // Get the new value from the input
                                            handleInputChange(staff.StaffID, newValue === '' ? '' : newValue); // Allow empty input
                                        }}
                                    />
                                </td>
                                <td>
                                    {/* Use an arrow function to pass the id correctly */}
                                    <Button variant="primary" onClick={() => handleSavePrice(staff.StaffID)}>Save</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                {/* <h2>Add New Year</h2>
                    <Form.Group controlId="newYear">
                        <Form.Label>Year</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={newYear} 
                            onChange={(e) => setNewYear(e.target.value)} 
                            placeholder="Enter new year" 
                        />
                    </Form.Group>
                    <Form.Group controlId="snPrice">
                        <Form.Label>SN Price</Form.Label>
                        <Form.Control 
                            type="number" 
                            value={snPrice} 
                            onChange={(e) => setSnPrice(e.target.value)} 
                            placeholder="Enter SN price" 
                        />
                    </Form.Group>
                    <Form.Group controlId="enaPrice">
                        <Form.Label>ENA Price</Form.Label>
                        <Form.Control 
                            type="number" 
                            value={enaPrice} 
                            onChange={(e) => setEnaPrice(e.target.value)} 
                            placeholder="Enter ENA price" 
                        />
                    </Form.Group>
                    <Form.Group controlId="cwPrice">
                        <Form.Label>CW Price</Form.Label>
                        <Form.Control 
                            type="number" 
                            value={cwPrice} 
                            onChange={(e) => setCwPrice(e.target.value)} 
                            placeholder="Enter CW price" 
                        />
                    </Form.Group>
                    <Button variant="primary" onClick={handleAddNewYear}>Add New Year</Button> */}
            </div>
        </div>
    );
};

export default StaffPrices;
